import { StyleSheet, Platform, Dimensions, type ViewStyle } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

const SMALL_SCREEN_MAX_WIDTH = 380;

export const getActionMenuDropdownStyles = (theme: Theme) => {
  const isSmall = Dimensions.get('window').width < SMALL_SCREEN_MAX_WIDTH;
  const windowWidth = Dimensions.get('window').width;

  return StyleSheet.create({
    backdrop: {
      flex: 1,
      backgroundColor: 'transparent',
      ...((Platform.OS === 'web' ? { cursor: 'default' } : {}) as ViewStyle),
    },
    dropdown: {
      minWidth: isSmall ? 120 : 160,
      maxWidth: isSmall ? windowWidth - 32 : undefined,
      backgroundColor: theme.cardActiveBg,
      borderRadius: isSmall ? 10 : 12,
      shadowColor: theme.shadow,
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.15,
      shadowRadius: 8,
      elevation: 4,
      overflow: 'hidden' as const,
      ...((Platform.OS === 'web' ? { cursor: 'default' } : {}) as ViewStyle),
    },
    option: {
      flexDirection: 'row' as const,
      alignItems: 'center' as const,
      gap: isSmall ? 8 : 10,
      paddingVertical: isSmall ? 10 : 12,
      paddingHorizontal: isSmall ? 10 : 14,
      ...((Platform.OS === 'web' ? { cursor: 'pointer' } : {}) as ViewStyle),
    },
    optionDisabled: {
      flexDirection: 'row' as const,
      alignItems: 'center' as const,
      gap: isSmall ? 8 : 10,
      paddingVertical: isSmall ? 10 : 12,
      paddingHorizontal: isSmall ? 10 : 14,
      opacity: 0.6,
    },
    optionTextBlock: {
      flex: 1,
    },
    optionText: {
      fontSize: isSmall ? 13 : 14,
      fontWeight: '500' as const,
      color: theme.gray[900],
    },
    optionTextDisabled: {
      fontSize: isSmall ? 13 : 14,
      fontWeight: '500' as const,
      color: theme.gray[500],
    },
    optionTextDanger: {
      fontSize: isSmall ? 13 : 14,
      fontWeight: '500' as const,
      color: theme.error,
    },
    optionReason: {
      fontSize: isSmall ? 10 : 11,
      fontWeight: '400' as const,
      color: theme.gray[500],
      marginTop: 2,
    },
  });
};

/** Absolute positioning style for the dropdown (top/right anchored). */
export const getActionMenuDropdownPosition = (top: number, right: number): ViewStyle => ({
  position: 'absolute',
  top,
  right,
});
